import React from 'react';
import '../css/gallery.css';

const Gallery = () => {
  return (
    <section className="gallery-section">
      <h2>Gallery</h2>
      <p>Here are some of my favorite photos:</p>
      {/* Add your photos or photo grid here */}
    </section>
  );
};

export default Gallery;
